import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { UserPrivateRoute } from './App'
import RouteTitleManager from './components/RouteTitleManager'
import Login from '../src/screens/auth/login/Login'
import Dashboard from '../src/screens/website/Dashboard'
import AIAssistant from './screens/AI/AI-assistant'
import ResetPasswordStepOne from './screens/auth/reset-password/ResetPasswordStepOne'
import ResetPasswordStepTwo from './screens/auth/reset-password/ResetPasswordStepTwo'
import SignUpCreatePassword from './screens/auth/sign-up/SignUpCreatePassword'
import SignUpPersonalInfo from './screens/auth/sign-up/SignUpPersonalInfo'
import VerifyEmail from './screens/auth/verify/VerifyEmail'
import BusinessCategory from './screens/business/BusinessCategory'
import BusinessLanding from './screens/business/BusinessLanding'
import CarCompanyInfo from './screens/business/business_products/CarCompanyInfo'
import CompanyContactInfo from './screens/business/business_products/CompanyContactInfo'
import HealthCompanyInfo from './screens/business/business_products/HealthCompanyInfo'
import OtherCompanyInfo from './screens/business/business_products/OtherCompanyInfo'
import PropertyCompanyinfo from './screens/business/business_products/PropertyCompanyinfo'
import LoggedUserLayout from './screens/logged_user/layout/LoggedUserLayout'
import Transactions from './screens/logged_user/payment/transactions/Transactions'
import MyPolicies from './screens/logged_user/policies/MyPolicies'
import PetPolicyDetail from './screens/logged_user/policies/detail/PetPolicyDetail'
import TplPolicyDetail from './screens/logged_user/policies/detail/TplPolicyDetail'
import TravelPolicyDetail from './screens/logged_user/policies/detail/TravelPolicyDetail'
import WelcomerPolicyDetail from './screens/logged_user/policies/detail/WelcomerPolicyDetail'
import Layout from './screens/nav/Layout'
import NotificationDetail from './screens/notifications/NotificationDetail'
import NotificationList from './screens/notifications/NotificationList'
import CriticalAddInsured from './screens/products/Critical-ilness/CriticalAddInsured'
import CriticalCheckInformation from './screens/products/Critical-ilness/CriticalCheckInformation'
import CriticalChooseMethod from './screens/products/Critical-ilness/CriticalChooseMethod'
import CriticalCurrencyAndLimit from './screens/products/Critical-ilness/CriticalCurrencyAndLimit'
import CriticalForMe from './screens/products/Critical-ilness/CriticalForMe'
import CriticalForMeAndOther from './screens/products/Critical-ilness/CriticalForMeAndOther'
import CriticalForOther from './screens/products/Critical-ilness/CriticalForOther'
import CriticalInsurer from './screens/products/Critical-ilness/CriticalInsurer'
import CriticalOffer from './screens/products/Critical-ilness/CriticalOffer'
import CriticalOffers from './screens/products/Critical-ilness/CriticalOffers'
import CriticalPayment from './screens/products/Critical-ilness/CriticalPayment'
import CriticalPolicyRegistration from './screens/products/Critical-ilness/CriticalPolicyRegistration'
import CriticalStartDate from './screens/products/Critical-ilness/CriticalStartDate'
import CriticalWhoDoYouInsure from './screens/products/Critical-ilness/CriticalWhoDoYouInsure'
import HealthCheckInformation from './screens/products/Health/HealthCheckInformation'
import HealthChooseMethod from './screens/products/Health/HealthChooseMethod'
import HealthCompareCompanies from './screens/products/Health/HealthCompareCompanies'
import HealthForMe from './screens/products/Health/HealthForMe'
import HealthForMeAndOther from './screens/products/Health/HealthForMeAndOther'
import HealthForOther from './screens/products/Health/HealthForOther'
import HealthInsurer from './screens/products/Health/HealthInsurer'
import HealthOffer from './screens/products/Health/HealthOffer'
import HealthOffers from './screens/products/Health/HealthOffers'
import HealthPayment from './screens/products/Health/HealthPayment'
import HealthPolicyRegistration from './screens/products/Health/HealthPolicyRegistration'
import HealthPriority from './screens/products/Health/HealthPriority'
import HealthStartDate from './screens/products/Health/HealthStartDate'
import HealthWhoDoYouInsure from './screens/products/Health/HealthWhoDoYouInsure'
import InternationalTplCarInfo from './screens/products/InternationalTPL/InternationalTplCarInfo'
import InternationalTplCheckInfo from './screens/products/InternationalTPL/InternationalTplCheckInfo'
import InternationalTplCountry from './screens/products/InternationalTPL/InternationalTplCountry'
import InternationalTplDays from './screens/products/InternationalTPL/InternationalTplDays'
import InternationalTplOffer from './screens/products/InternationalTPL/InternationalTplOffer'
import InternationalTplPayment from './screens/products/InternationalTPL/InternationalTplPayment'
import InternationalTplPersonalInfo from './screens/products/InternationalTPL/InternationalTplPersonalInfo'
import InternationalTplUser from './screens/products/InternationalTPL/InternationalTplUser'
import ChooseDays from './screens/products/Tpl/ChooseDays'
import ExtraServices from './screens/products/Tpl/ExtraServices'
import InsuranceFor from './screens/products/Tpl/InsuranceFor'
import TplCarInfo from './screens/products/Tpl/TplCarInfo'
import TplCheckInformation from './screens/products/Tpl/TplCheckInformation'
import TplForMe from './screens/products/Tpl/TplForMe'
import TplForOther from './screens/products/Tpl/TplForOther'
import TplInsurerInfo from './screens/products/Tpl/TplInsurerInfo'
import TplOffer from './screens/products/Tpl/TplOffer'
import TplOffers from './screens/products/Tpl/TplOffers'
import TplPayment from './screens/products/Tpl/TplPayment'
import TplPolicyRegistration from './screens/products/Tpl/TplPolicyRegistration'
import WhichCurrency from './screens/products/Tpl/WhichCurrency'
import WhichMethod from './screens/products/Tpl/WhichMethod'
import AbroadForMe from './screens/products/Travel/AbroadForMe'
import AbroadForMeAndOther from './screens/products/Travel/AbroadForMeAndOther'
import AbroadForOther from './screens/products/Travel/AbroadForOther'
import AbroadInsurer from './screens/products/Travel/AbroadInsurer'
import AbroadPayment from './screens/products/Travel/AbroadPayment'
import AddTravelers from './screens/products/Travel/AddTravelers'
import CheckInformation from './screens/products/Travel/CheckInformation'
import ChooseMethod from './screens/products/Travel/ChooseMethod'
import CurrencyAndLimit from './screens/products/Travel/CurrencyAndLimit'
import MultiSelectDate from './screens/products/Travel/MultiSelectDate'
import PolicyRegistration from './screens/products/Travel/PolicyRegistration'
import ProductDetail from './screens/products/Travel/ProductDetail'
import SelectRegion from './screens/products/Travel/SelectRegion'
import SingleOrMulti from './screens/products/Travel/SingleOrMulti'
import SingleSelectDate from './screens/products/Travel/SingleSelectDate'
import TravelOffer from './screens/products/Travel/TravelOffer'
import TravelOffers from './screens/products/Travel/TravelOffers'
import WhoDoYouInsure from './screens/products/Travel/WhoDoYouInsure'
import WelcomerAddTravelers from './screens/products/Welcomer/WelcomerAddTravelers'
import WelcomerCheckInformation from './screens/products/Welcomer/WelcomerCheckInformation'
import WelcomerChooseMethod from './screens/products/Welcomer/WelcomerChooseMethod'
import WelcomerCurrencyAndLimit from './screens/products/Welcomer/WelcomerCurrencyAndLimit'
import WelcomerForMe from './screens/products/Welcomer/WelcomerForMe'
import WelcomerForMeAndOther from './screens/products/Welcomer/WelcomerForMeAndOther'
import WelcomerForOther from './screens/products/Welcomer/WelcomerForOther'
import WelcomerInsurer from './screens/products/Welcomer/WelcomerInsurer'
import WelcomerOffer from './screens/products/Welcomer/WelcomerOffer'
import WelcomerOffers from './screens/products/Welcomer/WelcomerOffers'
import WelcomerPayment from './screens/products/Welcomer/WelcomerPayment'
import WelcomerPolicyRegistration from './screens/products/Welcomer/WelcomerPolicyRegistration'
import WelcomerStartDate from './screens/products/Welcomer/WelcomerStartDate'
import WelcomerWhoDoYouInsure from './screens/products/Welcomer/WelcomerWhoDoYouInsure'
import ChoosePet from './screens/products/pet/ChoosePet'
import PetCheckInformation from './screens/products/pet/PetCheckInformation'
import PetInfo from './screens/products/pet/PetInfo'
import PetInsurer from './screens/products/pet/PetInsurer'
import PetOffer from './screens/products/pet/PetOffer'
import PetOfferMethod from './screens/products/pet/PetOfferMethod'
import PetOffers from './screens/products/pet/PetOffers'
import PetPayment from './screens/products/pet/PetPayment'
import PetPolicyRegistration from './screens/products/pet/PetPolicyRegistration'
import PetStartDate from './screens/products/pet/PetStartDate'
import AboutUs from './screens/website/AboutUs'
import Category from './screens/website/Category'
import Consent from './screens/website/Consent'
import DownloadPolicies from './screens/website/DownloadPolicies'
import FAQ from './screens/website/FAQ'
import Landing from './screens/website/Landing'
import OurPartners from './screens/website/OurPartners'
import PayFailureScreen from './screens/website/PayFailureScreen'
import PaySuccessful from './screens/website/PaySuccessful'
import Privacy from './screens/website/Privacy'
import Profile from './screens/website/Profile'
import Security from './screens/website/Security'
import TermsAndConditions from './screens/website/TermsAndConditions'
import InternationalTplPolicyDetail from './screens/logged_user/policies/detail/InternationalTplPolicyDetail'

const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <RouteTitleManager />

        <Routes>
          {/* landing screen */}
          <Route
            path="/"
            element={
              <Layout>
                <Landing />
              </Layout>
            }
          />
          {/* category screen */}
          <Route path="/category" element={<Category />} />
          {/* login screen */}
          <Route path="/login" element={<Login />} />
          {/* payment faulure */}
          <Route path="/pay/payment-failure" element={<PayFailureScreen />} />
          {/* payment successful */}
          <Route path="/pay/payment-success" element={<PaySuccessful />} />
          {/* reset password step one screen */}
          <Route path="/reset-password" element={<ResetPasswordStepOne />} />
          {/* reset password step two screen*/}
          <Route path="/reset-password-create/:token" element={<ResetPasswordStepTwo />} />
          {/*  */}
          <Route path="/auth/personal-info" element={<SignUpPersonalInfo />} />
          {/*  */}
          <Route path="/auth/create-password" element={<SignUpCreatePassword />} />
          {/* dashboard screen */}
          <Route
            path="/dashboard"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <Dashboard />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />
          {/* notifications page */}
          <Route
            path="/notification-list"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <NotificationList />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />
          {/* notification detailed page */}
          <Route
            path="/notification-details"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <NotificationDetail />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />
          {/* profile screen */}
          <Route
            path="/profile"
            element={
              <UserPrivateRoute>
                <Profile />
              </UserPrivateRoute>
            }
          />
          {/* user verify email */}
          <Route path="/verify-email/*" element={<VerifyEmail />} />
          <Route
            path="/security"
            element={
              <UserPrivateRoute>
                <Security />
              </UserPrivateRoute>
            }
          />
          {/* logged user policies */}
          <Route
            path="/my-policies"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <MyPolicies />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />
          {/* logged user Transactions */}
          <Route
            path="/transactions"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <Transactions />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />
          {/* logged user Policy detailed page */}
          <Route
            path="/travel-policy-detail/:policyId"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <TravelPolicyDetail />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />

          {/* logged user TPL Policy detailed page */}
          <Route
            path="/tpl-policy-detail/:policyId"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <TplPolicyDetail />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />

          <Route
            path="/international-tpl-policy-detail/:policyId"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <InternationalTplPolicyDetail />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />

          {/* logged user Welcomer Policy detailed page */}
          <Route
            path="/welcomer-policy-detail/:policyId"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <WelcomerPolicyDetail />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />

          {/* logged user Pet Policy detailed page */}
          <Route
            path="/pet-policy-detail/:policyId"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <PetPolicyDetail />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />

          {/* terms */}
          <Route
            path="/terms-and-conditions"
            element={
              <Layout>
                <TermsAndConditions />
              </Layout>
            }
          />
          {/* Privacy */}
          <Route
            path="/privacy"
            element={
              <Layout>
                <Privacy />
              </Layout>
            }
          />
          {/* Privacy */}
          <Route
            path="/consent"
            element={
              <Layout>
                <Consent />
              </Layout>
            }
          />
          {/* about us */}
          <Route
            path="/about-us"
            element={
              <Layout>
                <AboutUs />
              </Layout>
            }
          />
          {/* FAQ */}
          <Route
            path="/faq"
            element={
              <Layout>
                <FAQ />
              </Layout>
            }
          />

          <Route
            path="/our-partners"
            element={
              <Layout>
                <OurPartners />
              </Layout>
            }
          />

          {/*########### !TAVEL FLOW  ###########*/}

          <Route path="/single-or-multi" element={<SingleOrMulti />} />

          <Route path="/single-select-date" element={<SingleSelectDate />} />

          <Route path="/select-region" element={<SelectRegion />} />

          <Route path="/multi-select-date" element={<MultiSelectDate />} />

          <Route path="/currency-and-limit" element={<CurrencyAndLimit />} />

          <Route path="/add-travelers" element={<AddTravelers />} />

          <Route path="/choose-method" element={<ChooseMethod />} />

          <Route path="/travel-offers" element={<TravelOffers />} />

          <Route path="/travel-offer" element={<TravelOffer />} />

          <Route path="/who-do-you-insure" element={<WhoDoYouInsure />} />

          <Route path="/abroad-for-me" element={<AbroadForMe />} />

          <Route path="/abroad-for-other" element={<AbroadForOther />} />

          <Route path="/abroad-insurer" element={<AbroadInsurer />} />

          <Route path="/abroad-for-me-and-other" element={<AbroadForMeAndOther />} />

          <Route path="/abroad-check-information" element={<CheckInformation />} />

          <Route path="/policy-registration" element={<PolicyRegistration />} />

          <Route path="/abroad-payment" element={<AbroadPayment />} />

          <Route
            path="/:type/product-detail"
            element={
              <Layout>
                <ProductDetail />
              </Layout>
            }
          />
          {/*########### !TAVEL FLOW ###########*/}

          {/*########### !TPL FLOW  ###########*/}

          <Route path="/tpl-choose-days" element={<ChooseDays />} />

          <Route path="/tpl-which-currency" element={<WhichCurrency />} />

          <Route path="/tpl-extra-services" element={<ExtraServices />} />

          <Route path="/tpl-which-method" element={<WhichMethod />} />

          <Route path="/tpl-offers" element={<TplOffers />} />

          <Route path="/tpl-offer" element={<TplOffer />} />

          <Route path="/tpl-insurance-for" element={<InsuranceFor />} />

          <Route path="/tpl-for-me" element={<TplForMe />} />

          <Route path="/tpl-for-other" element={<TplForOther />} />

          <Route path="/tpl-insurer" element={<TplInsurerInfo />} />

          <Route path="/tpl-car-info" element={<TplCarInfo />} />

          <Route path="/tpl-check-information" element={<TplCheckInformation />} />

          <Route path="/tpl-policy-registration" element={<TplPolicyRegistration />} />

          <Route path="/tpl-payment" element={<TplPayment />} />
          {/*########### !TPL FLOW  ###########*/}

          {/*########### !Health FLOW  ###########*/}
          <Route path="/health-compare-companies" element={<HealthCompareCompanies />} />

          <Route path="/health-priority" element={<HealthPriority />} />

          <Route path="/health-start-date" element={<HealthStartDate />} />

          <Route path="/health-choose-method" element={<HealthChooseMethod />} />

          {/* <Route path="/health-payment-schedule" element={<HealthPaymentSchedule />} /> */}

          <Route path="/health-offers" element={<HealthOffers />} />

          <Route path="/health-offer" element={<HealthOffer />} />

          <Route path="/health-who-do-you-insure" element={<HealthWhoDoYouInsure />} />

          <Route path="/health-for-me" element={<HealthForMe />} />

          <Route path="/health-for-other" element={<HealthForOther />} />

          <Route path="/health-insurer" element={<HealthInsurer />} />

          <Route path="/health-for-me-and-other" element={<HealthForMeAndOther />} />

          <Route path="/health-check-information" element={<HealthCheckInformation />} />

          <Route path="/health-policy-registration" element={<HealthPolicyRegistration />} />

          <Route path="/health-payment" element={<HealthPayment />} />

          {/*########### !HEALTH FLOW  ###########*/}

          {/*########### !CRITICAL ILLNESS FLOW  ###########*/}
          <Route path="/critical-start-date" element={<CriticalStartDate />} />

          <Route path="/critical-choose-currency" element={<CriticalCurrencyAndLimit />} />

          <Route path="/critical-choose-method" element={<CriticalChooseMethod />} />

          <Route path="/critical-who-do-you-insure" element={<CriticalWhoDoYouInsure />} />

          <Route path="/critical-for-me" element={<CriticalForMe />} />

          <Route path="/critical-for-other" element={<CriticalForOther />} />

          <Route path="/critical-for-me-and-other" element={<CriticalForMeAndOther />} />

          <Route path="/critical-insurer" element={<CriticalInsurer />} />

          <Route path="/critical-offer" element={<CriticalOffer />} />

          <Route path="/critical-offers" element={<CriticalOffers />} />

          <Route path="/critical-add-insured" element={<CriticalAddInsured />} />

          <Route path="/critical-policy-registration" element={<CriticalPolicyRegistration />} />

          <Route path="/critical-check-information" element={<CriticalCheckInformation />} />

          <Route path="/critical-payment" element={<CriticalPayment />} />

          {/*########### !CRITICAL HEALTH FLOW  ###########*/}

          {/*########### !WELCOMER INSURANCE FLOW  ###########*/}

          <Route path="/welcomer-start-date" element={<WelcomerStartDate />} />

          <Route path="/welcomer-currency-and-limit" element={<WelcomerCurrencyAndLimit />} />

          <Route path="/welcomer-add-travelers" element={<WelcomerAddTravelers />} />

          <Route path="/welcomer-choose-method" element={<WelcomerChooseMethod />} />

          <Route path="/welcomer-offers" element={<WelcomerOffers />} />

          <Route path="/welcomer-offer" element={<WelcomerOffer />} />

          <Route path="/welcomer-who-do-you-insure" element={<WelcomerWhoDoYouInsure />} />

          <Route path="/welcomer-for-me" element={<WelcomerForMe />} />

          <Route path="/welcomer-for-other" element={<WelcomerForOther />} />

          <Route path="/welcomer-insurer" element={<WelcomerInsurer />} />

          <Route path="/welcomer-for-me-and-other" element={<WelcomerForMeAndOther />} />

          <Route path="/welcomer-check-information" element={<WelcomerCheckInformation />} />

          <Route path="/welcomer-policy-registration" element={<WelcomerPolicyRegistration />} />

          <Route path="/welcomer-payment" element={<WelcomerPayment />} />

          {/*########### !WELCOMER INSURANCE FLOW  ###########*/}

          {/* ########### !BUSINESS INSURANCE FLOW  ########### */}
          <Route
            path="business"
            element={
              <Layout>
                <BusinessLanding />
              </Layout>
            }
          />
          <Route
            path="business-category"
            element={
              <Layout>
                <BusinessCategory />
              </Layout>
            }
          />
          <Route path="/company-contact-info" element={<CompanyContactInfo />} />
          <Route path="/health-company-info" element={<HealthCompanyInfo />} />
          <Route path="/car-company-info" element={<CarCompanyInfo />} />
          <Route path="/property-company-info" element={<PropertyCompanyinfo />} />
          <Route path="/other-company-info" element={<OtherCompanyInfo />} />
          {/* ########### !BUSINESS INSURANCE FLOW  ########### */}

          {/* ########### PET FLOW  ########### */}
          <Route path="/choose-pet" element={<ChoosePet />} />

          <Route path="/pet-info" element={<PetInfo />} />

          <Route path="/pet-start-date" element={<PetStartDate />} />

          <Route path="/pet-offer-method" element={<PetOfferMethod />} />

          <Route path="/pet-offers" element={<PetOffers />} />

          <Route path="/pet-offer" element={<PetOffer />} />

          <Route path="/pet-insurer" element={<PetInsurer />} />

          <Route path="/pet-check-information" element={<PetCheckInformation />} />

          <Route path="/pet-policy-registration" element={<PetPolicyRegistration />} />

          <Route path="/pet-payment" element={<PetPayment />} />

          {/* ########### PET FLOW  ########### */}

          {/* ########### International TPL  ########### */}

          <Route path="/international-tpl-country" element={<InternationalTplCountry />} />
          <Route path="/international-tpl-days" element={<InternationalTplDays />} />
          <Route path="/international-tpl-personal-info" element={<InternationalTplPersonalInfo />} />
          <Route path="/international-tpl-car-info" element={<InternationalTplCarInfo />} />
          <Route path="/international-tpl-user" element={<InternationalTplUser />} />
          <Route path="/international-tpl-offer" element={<InternationalTplOffer />} />
          <Route path="/international-tpl-check-info" element={<InternationalTplCheckInfo />} />
          <Route path="/international-tpl-payment" element={<InternationalTplPayment />} />

          {/* ########### International TPL  ########### */}

          <Route
            path="/ai-assistent"
            element={
              <UserPrivateRoute>
                <LoggedUserLayout>
                  <AIAssistant />
                </LoggedUserLayout>
              </UserPrivateRoute>
            }
          />

          {/* consent for dialog */}
          <Route path="/consent-dialog" element={<Consent dialog={true} />} />

          {/* terms for dialog */}
          <Route path="/terms-and-conditions-dialog" element={<TermsAndConditions dialog={true} />} />
          <Route path="/policies/:encode" element={<DownloadPolicies />} />

          {/* some routes */}
          <Route path="*" element={<Navigate to={`/`} replace />} />
          {/* some routes */}
        </Routes>

    </BrowserRouter>
  )
}

export default AppRoutes
